import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import FeaturedLiteraryJourney from "./sections/FeaturedLiteraryJourney";
import HeritageHospitality from "./sections/HeritageHospitality";
import WhyChooseAnnabriel from "./sections/WhyChooseAnnabriel";
import ThePathToSuccess from "./sections/ThePathToSuccess";
import RealResultsForDelhiClinics from "./sections/RealResultsForDelhiClinics";
import OgrenciVeOgretmenGorusleri from "./sections/OgrenciVeOgretmenGorusleri";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <FeaturedLiteraryJourney />
      <HeritageHospitality />
      <WhyChooseAnnabriel />
      <ThePathToSuccess />
      <RealResultsForDelhiClinics />
      <OgrenciVeOgretmenGorusleri />
      <Footer />
    </div>;
}